import React from "react";
import { Heart, Users, HandHeart, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

// Import images
import donations from "../../assets/image/donations.png";
import volunteer from "../../assets/image/volunteer.png";
import sponsorship from "../../assets/image/sponsorship.png";

const JoinUsCard = ({ activity, index, totalItems }) => {
  // Icons for each activity
  const icons = [
    <Heart size={24} className="text-rose-600" />,
    <Users size={24} className="text-blue-600" />,
    <HandHeart size={24} className="text-amber-600" />,
  ];

  // Colors for each card
  const colors = [
    { bg: "bg-rose-50", border: "border-rose-200", hover: "hover:bg-rose-100" },
    { bg: "bg-blue-50", border: "border-blue-200", hover: "hover:bg-blue-100" },
    {
      bg: "bg-amber-50",
      border: "border-amber-200",
      hover: "hover:bg-amber-100",
    },
  ];

  // Action buttons text
  const actionTexts = ["অনুদান করুন", "গর্বিত সদস্য নিবন্ধন", "স্পন্সর হোন"];

  // Routes for action buttons
  const routes = ["/donation", "/register", "/sponsor-child"];

  // Calculate animation delay
  const animDelay = index * 100;

  return (
    <div
      data-aos="fade-up"
      data-aos-delay={animDelay}
      data-aos-duration="800"
      className={`relative rounded-2xl ${colors[index].bg} ${colors[index].border} ${colors[index].hover} border transition-all duration-300 h-full shadow-md hover:shadow-xl`}
    >
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-white/40 to-transparent rounded-tr-2xl"></div>

      {/* Card content */}
      <div className="p-6 flex flex-col h-full">
        {/* Image and title section */}
        <div className="flex items-center mb-4">
          <div className="p-3 rounded-full bg-white shadow-sm mr-4">
            <img
              src={activity.image}
              alt={activity.name}
              className="w-16 h-16 object-contain"
            />
          </div>
          <div>
            <div className="flex items-center">
              {icons[index]}
              <h3 className="text-xl md:text-2xl font-bold ml-2 text-gray-800">
                {activity.name}
              </h3>
            </div>
            <div className="h-1 w-20 bg-gradient-to-r from-primary to-transparent mt-2"></div>
          </div>
        </div>

        {/* Description */}
        <p className="text-gray-700 mb-6 flex-grow">{activity.description}</p>

        {/* Action button */}
        <Link
          to={routes[index]}
          className="inline-flex items-center justify-between mt-auto bg-white border border-gray-300 hover:border-primary text-primary hover:bg-primary hover:text-white px-5 py-3 rounded-lg font-medium transition-all duration-300"
        >
          <span>{actionTexts[index]}</span>
          <ChevronRight size={20} />
        </Link>
      </div>
    </div>
  );
};

const JoinUs = () => {
  const joinUsActivities = [
    {
      id: 1,
      name: "অনুদান",
      image: donations,
      description:
        "আমাদের এই সামাজিক কার্যক্রম কে আরো এগিয়ে নিতে দরকার আপনাদের আর্থিক অনুদান। আপনার অনুদানের মাধ্যমেই এই সামাজিক কার্যক্রম এগিয়ে যাবে সবসময়।",
    },
    {
      id: 2,
      name: "গর্বিত সদস্য",
      image: volunteer,
      description:
        "আপনি কি NNS এর একজন গর্বিত সদস্য হতে ইচ্ছুক? আপনি আমাদের সাথে নিঃস্বার্থ মনন লালনের মাধ্যমে আপনার সময়, দক্ষতা এবং জ্ঞান অবদান রাখতে পারেন। এটি একটি ইতিবাচক প্রভাব তৈরি করার সুযোগ এবং আত্মতৃপ্তি, শান্তি ও উন্নয়ন অর্জনের জন্য একটি গুরুত্বপূর্ণ শক্তি যা অনেকের জীবনে একটা পার্থক্য গড়ে তুলুন!",
    },
    {
      id: 3,
      name: "স্পন্সরশিপ",
      image: sponsorship,
      description:
        "আপনার ব্যবসা বা অন্য যেকোনো প্রতিষ্ঠান মাধ্যমে আমাদের এই প্রতিষ্ঠানে Sponsorship দিন। এতে করে আমাদের এসব সামাজিক কার্যক্রম আরোও অগ্রসর হবে।",
    },
  ];

  return (
    <section className="mt-20 px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <span className="text-primary font-medium">সহযোগিতা করুন</span>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2 mb-4">
          আমাদের কার্যক্রমে যুক্ত হোন
        </h2>
        <div className="w-24 h-1 bg-primary mx-auto mb-6"></div>
        <p className="max-w-2xl mx-auto text-gray-600">
          আপনার সহযোগিতা আমাদের কার্যক্রমকে আরও শক্তিশালী করবে। আপনি বিভিন্নভাবে
          আমাদের সাথে যুক্ত হয়ে সমাজের উন্নয়নে ভূমিকা রাখতে পারেন।
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {joinUsActivities.map((activity, index) => (
          <JoinUsCard
            key={activity.id}
            activity={activity}
            index={index}
            totalItems={joinUsActivities.length}
          />
        ))}
      </div>

      <div className="text-center mt-12">
        <Link
          to="/about"
          className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-8 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
        >
          আরও জানতে যোগাযোগ করুন
          <ChevronRight size={20} />
        </Link>
      </div>
    </section>
  );
};

export default JoinUs;
